"use client";

import clsx from "clsx";
import { usePathname } from "next/navigation";
import React from "react";

import useMediaQuery from "hooks/useMediaQuery";

import { resolveSlugAndPath, shouldHideMobileMenu } from ".";
import navigationStyles from "./navigation.module.css";
import { shouldHideDesktopNavigation } from "./navigationVisibility";

export default function NavigationWrapper({
  children,
  className,
}: {
  children?: React.ReactNode;
  className?: string;
}) {
  const pathname = usePathname() ?? "";
  const isTablet = useMediaQuery("tablet");
  const is404 = pathname === "/404";
  const { slug } = resolveSlugAndPath(pathname, isTablet);
  const isForsakringPages = slug === "forsakring" || pathname.startsWith("/forsakring/");
  const hideDesktopNavigation = shouldHideDesktopNavigation(slug, is404, pathname);
  const hideMobileMenu = shouldHideMobileMenu(slug);

  return (
    <div
      className={clsx(navigationStyles.navigationWrapper, className, {
        [navigationStyles.hideInDesktop]: hideDesktopNavigation,
        [navigationStyles.hideInMobile]: hideMobileMenu,
        [navigationStyles.hideColumnTwo]: !isForsakringPages,
      })}
    >
      {children}
    </div>
  );
}
